import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';

import { SlicePipe } from '@angular/common';

import { Subscription } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';

import type { IOrderInformation } from './order-information.interface';
import {
  DeviceService,
  ImageRatioEnum,
  SdBannerComponent,
  SdConvertedPriceComponent,
  SdLinkComponent,
  StatusEnum
} from '@seb/web-design-system/core';

@Component({
  selector: 'sd-order-information',
  templateUrl: './order-information.component.html',
  styleUrls: ['./order-information.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    SdBannerComponent,
    SdLinkComponent,
    SlicePipe,
    TranslateModule,
    SdConvertedPriceComponent
  ]
})
export class SdOrderInformationComponent implements OnInit, OnDestroy {
  constructor(
    private cdRef: ChangeDetectorRef,
    private deviceService: DeviceService,
  ) {}

  statusEnum = StatusEnum;
  imageRatioEnum = ImageRatioEnum;
  maxProductDisplayed = 5;
  mobileSubscription: Subscription;
  isMobile$: boolean;

  @Input()
  order: IOrderInformation;

  ngOnInit() {
    this.mobileSubscription = this.deviceService.isMobile.subscribe((x) => {
      this.isMobile$ = x;
      this.maxProductDisplayed = this.isMobile$ ? 4 : 5;
      this.cdRef.markForCheck();
    });
  }

  ngOnDestroy() {
    this.mobileSubscription?.unsubscribe();
  }
}
